export default defineNuxtPlugin(async (nuxtApp) => {
  nuxtApp.hook('app:mounted', async () => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.onmessage = (event) => {
        const { action, actionValue } = event.data;
      };
    }
  });
});
